<template>
  <div class="d-lg-flex">
    <div class="side-menu flex-lg-column mr-lg-1">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <router-link
          to="/"
          class="logo"
        >
          <span class="logo-sm">
            <img
              src="@/assets/images/logo.png"
              alt
              height="30"
            >
          </span>
        </router-link>
      </div>
      <!-- end navbar-brand-box -->

      <!-- Start side-menu nav -->
      <div class="flex-lg-column">
        <ul
          class="nav nav-pills side-menu-nav justify-content-center"
          role="tablist"
        >
          <li
            class="nav-item"
            data-placement="top"
            :title="$t('home.profile')"
          >
            <a
              id="pills-user-tab"
              class="nav-link"
              data-toggle="pill"
              :class="[activetab === 1 ? 'active' : '']"
              role="tab"
              href="javascript: void(0);"
              @click="activetab = 1"
            >
              <img
                :onerror="`this.src = '${require('@/static/user__1_.png')}'`"
                :src="profileAvatarImage"
                alt
                class="profile-user rounded-circle"
              >
            </a>
          </li>
          <li
            class="nav-item"
            data-placement="top"
            :title="$t('home.chats')"
          >
            <a
              id="pills-chat-tab"
              class="nav-link"
              data-toggle="pill"
              :class="[activetab === 2 ? 'active' : '']"
              role="tab"
              href="javascript: void(0);"
              @click="activetab = 2"
            >
              <i class="ri-message-3-line" />
            </a>
          </li>
          <li
            class="nav-item"
            data-placement="top"
            :title="$t('home.settings')"
          >
            <a
              id="pills-setting-tab"
              class="nav-link"
              data-toggle="pill"
              :class="[activetab === 5 ? 'active' : '']"
              role="tab"
              href="javascript: void(0);"
              @click="activetab = 5"
            >
              <i class="ri-settings-2-line" />
            </a>
          </li>
          <li
            class="nav-item d-lg-none"
            data-placement="top"
            :title="$t('home.settings')"
          >
            <router-link
              id="pills-setting-tab"
              :to="'/logout'"
              class="nav-link"
              data-toggle="pill"
              :class="[activetab === 5 ? 'active' : '']"
              role="tab"
              href="javascript: void(0);"
              @click="activetab = 5"
            >
              <i class="ri-logout-circle-r-line" />
            </router-link>
          </li>
        </ul>
      </div>
      <!-- end side-menu nav -->

      <div class="flex-lg-column d-none d-lg-block mt-auto">
        <ul class="nav side-menu-nav justify-content-center">
          <li
            class="nav-item"
            data-placement="top"
            :title="$t('home.log_out')"
          >
            <router-link
              id="pills-setting-tab"
              :to="'/logout'"
              class="nav-link"
              data-toggle="pill"
              role="tab"
            >
              <i class="ri-logout-circle-r-line" />
            </router-link>
          </li>
        </ul>
      </div>
      <!-- Side menu user -->
    </div>
    <div class="chat-leftsidebar mr-lg-1">
      <div class="tab-content">
        <div
          v-if="activetab === 1"
          id="pills-user"
          class="tab-pane"
          role="tabpanel"
          aria-labelledby="pills-user-tab"
          :class="[activetab === 1 ? 'active' : '']"
        >
          <profile />
        </div>

        <div
          v-if="activetab === 2"
          id="pills-chat"
          class="tab-pane fade show active"
          role="tabpanel"
          aria-labelledby="pills-chat-tab"
          :class="[activetab === 2 ? 'active' : '']"
        >
          <rooms-chats />
        </div>

        <!--div
          v-if="activetab === 3"
          id="pills-groups"
          class="tab-pane"
          role="tabpanel"
          aria-labelledby="pills-groups-tab"
          :class="[activetab === 3 ? 'active' : '']"
        >
          <Groups />
        </div-->

        <!--div
          v-if="activetab === 4"
          id="pills-contacts"
          class="tab-pane"
          role="tabpanel"
          aria-labelledby="pills-contacts-tab"
          :class="[activetab === 4 ? 'active' : '']"
        >
          <Contacts />
        </div-->

        <div
          v-if="activetab === 5"
          id="pills-setting"
          class="tab-pane"
          role="tabpanel"
          aria-labelledby="pills-setting-tab"
          :class="[activetab === 5 ? 'active' : '']"
        >
          <setting />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import Contacts from "../../pages/chat/tabs/contacts"
//import Groups from "../../pages/chat/tabs/groups"
import Profile from "../pages/tab/Profile"
import RoomsChats from "./Rooms/ChatsRoomsComponents"
import Setting from "../pages/tab/Setting"
import {mapGetters} from "vuex";

export default {
  name: 'ChatLeftSidebar',
  components: {
    //Contacts,
    //Groups,
    Profile,
    RoomsChats,
    Setting,
  },
  data: () => ({
    activetab: 2,
  }),
  computed: {
    ...mapGetters('auth', ['user']),
    profileAvatarImage() {
      return this.user.avatar_image_url || require('@/static/user__1_.png')
    },
  },
}
</script>
